import ContactUsLink from './ContactUsLink';

function SectionNine() {
  return (
    <section className="py-14 flex flex-col gap-4 md:gap-6 items-center">
      <header>
        <h2 className="text-center text-2xl md:text-4xl font-bold">
          Have More Questions
          <br />
          <span className="text-gold">Kindly Send us a Message</span>
        </h2>
      </header>
      <div>
        <ContactUsLink
          childEl={
            <button
              type="button"
              className="p-3.5 md:p-5 md:rounded-xl md:text-2xl text-lg bg-gold text-white font-bold rounded-xl"
            >
              Contact Us
            </button>
          }
        />
      </div>
    </section>
  );
}

export default SectionNine;
